module.exports = __webpack_public_path__ + "static/media/quiz_icon--active.2e25f16d.svg";